import {Alert, Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ServiceRequestForm} from "./service_request_form";
import {getPersonServices} from "../../services/service/service";
import {PersonServiceGrid} from "./person_service_grid";
import {PersonServiceCheckForm} from "./person_service_check";
import {PersonServiceDocumentationForm} from "./person_service_documentation_form";
import {InvoiceForm} from "./invoice_form";
import {ServiceContext} from "./service_context";
import {ChargeWalletForm} from "./charge_wallet_form";
import {ServiceActivities} from "./service_activity";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {AgentPanel} from "../system/agents_panel";
import {ConfirmationForm} from "./confirmation_form";
import {BsInfoCircle} from "react-icons/bs";
import {GuideForm} from "./guide_form";


export function PersonServiceManagement() {


  const handleOpen = () => setModalOpen(!modalOpen);

  const [step, setStep] = useState(null);

  const [personServices, setPersonServices] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [documentGridSelectedRow, setDocumentGridGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [agentId, setAgentId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [branchInfo, setBranchInfo] = useState(null)

  const [show, setShow] = useState(2);

  useEffect(() => {
    if (localStorage.getItem("agentId")) {
      const new_agent_id = localStorage.getItem("agentId")
      setAgentId(new_agent_id)
      localStorage.removeItem("agentId")
    }

    if (localStorage.getItem("branchId")) {
      const new_branch_id = localStorage.getItem("branchId")
      setBranchId(new_branch_id)
      localStorage.removeItem("branchId")
    }

    setDataLoaded(true);
  }, [])

  const [chargeAmount, setChargeAmount] = useState(null);
  const [chargeDiscountCode, setChargeDiscountCode] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getPersonServices(paginate);
    if (result.status === 200) {
      const {personServiceList, total_count} = result.data;
      setPersonServices(personServiceList || []);
      setGridTotalRowCount(total_count);
      if (gridSelectedRow?.id) {
        const selectedService = personServiceList.find((item) => item.id === gridSelectedRow.id)
        setGridSelectedRow(selectedService)
        setStep("check")
        // handleOpen()
      }
    }

  }


  useEffect(() => {
    let service = localStorage.getItem("service")
    let discountCode = localStorage.getItem("discountCode")
    if (service) {
      service = JSON.parse(service)
      setGridSelectedRow(service)
      setModalOpen(true)
      setChargeDiscountCode(discountCode)
      setStep("invoice")
      localStorage.removeItem("service")
      localStorage.removeItem("discountCode")
    }

    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);


  if (dataLoaded) {
    return (
      <ServiceContext.Provider value={{
        modalOpen,
        setModalOpen,
        gridRowCount,
        setGridRowCount,
        gridCurrentPage,
        setGridCurrentPage,
        service: gridSelectedRow,
        setService: setGridSelectedRow,
        document: documentGridSelectedRow,
        setDocument: setDocumentGridGridSelectedRow,
        lastDataRefresh,
        setLastDataRefresh,
        step,
        setStep,
        from: "person",
        chargeAmount,
        setChargeAmount,
        chargeDiscountCode,
        setChargeDiscountCode,
        branchInfo,
        setBranchInfo,
        show,
        setShow
      }}>
        <div className="">
          {step === "check" &&
            <PersonServiceCheckForm/>
          }
          {step === "documentation" &&
            <PersonServiceDocumentationForm/>
          }
          {step === "new" &&
            <ServiceRequestForm agentId={agentId}/>
          }
          {step === "invoice" &&
            <InvoiceForm/>
          }
          {step === "charge_wallet" &&
            <ChargeWalletForm/>
          }
          {step === "report" &&
            <ServiceActivities/>
          }
          {step === "confirmation" &&
            <ConfirmationForm/>
          }
          {step === "guide" &&
            <GuideForm/>
          }
          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="flex flex-row rounded-none justify-between">
              <div className="mb-8 flex items-center justify-between">
                <Typography variant="h5" color="blue-gray">خدمات من</Typography>
              </div>
              <Button className="flex items-center gap-x-2 py-0 h-12" size="small" variant="outlined" onClick={() => {
                setStep("guide")
                setModalOpen(true)
              }}>
                <BsInfoCircle className="h-5 w-5"/>
                <Typography className="font-light">
                  راهنما
                </Typography>
              </Button>
            </CardHeader>

            <div className="w-full mb-4">
              <AgentPanel
                agent_id={agentId}
                branch_id={branchId}
                setAgentId={setAgentId}
                type="service"
              />
            </div>

            <CardBody className="overflow-x-auto w-full">
              <Alert className="mt-8 w-full px-2" variant="gradient">
                <Typography variant="h5" className="mb-4">
                  کاربر گرامی؛
                </Typography>
                <Typography variant="body" className="px-4">
                  <li>
                    از طریق دکمه مشاهده/بررسی مدارک می توانید مدارک و مستندات خود را برای مشاور
                    ارسال نمائید.
                    هزینه‌های جانبی و دولتی خدمت، در قیمت ها لحاظ نشده است و باید توسط خودتان پرداخت
                    گردد.
                  </li>
                  <li>
                    پس از پرداخت، فرآیند خدمت آغاز خواهد شد و مشاور موظف است پس از پایان هر مرحله
                    از خدمت، گزارش پیشرفت خدمت را به شما اطلاع رسانی نماید.
                  </li>
                  <li>
                    بدیهی است در صورت عدم تامین مدارک و مستندات لازم از سوی کاربر، هرگونه تاخیر و
                    تبعات بر عهده کاربر خواهد بود.
                  </li>
                </Typography>
              </Alert>

              <PersonServiceGrid
                PersonServices={personServices}
                setSortBy={setSortBy}
                sortType={sortType}
                setSortType={setSortType}
              />
            </CardBody>

            <CardFooterPaginator
              active={gridCurrentPage}
              setActive={setGridCurrentPage}
              totalRows={gridTotalRowCount}
              rowsCount={gridRowCount}
              setRowsCount={setGridRowCount}
              from={from}
              to={to}
            />
          </Card>
        </div>
      </ServiceContext.Provider>
    );
  }
}